import React from 'react'
import { MotionCard, MotionSection } from '../components/motion/Motion'
import SEO from '../components/seo/SEO'

export default function TermsAndConditionsOfSale() {
  return (
    <>
      <SEO
        title="Terms and Conditions of Sale | Logo Branded Door Mats Johannesburg"
        description="Read the terms and conditions of sale for Logo Branded Door Mats Johannesburg. Information about ZAR pricing, 50% deposit, POPIA privacy, delivery, and returns for custom branded entrance mats."
        keywords="terms and conditions South Africa, custom mat sale conditions, POPIA privacy mat, ZAR mat purchase terms, branded mat conditions Johannesburg, mat warranty South Africa"
        url="https://www.logobrandeddoormats.co.za/terms-and-conditions-of-sale"
        image="https://www.logobrandeddoormats.co.za/images/logo/LOGO%20HEADER.png"
      />
      <MotionSection className="w-[96%] mx-auto py-12 lg:py-16">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-3xl sm:text-4xl font-bold text-pink-500">Terms and Conditions of Sale</h1>
        <p className="mt-3 text-sm sm:text-base text-gray-700 leading-relaxed">
          These Terms and Conditions of Sale apply to all orders placed with{' '}
          <span className="font-semibold text-pink-500">Logo Branded Door Mats Johannesburg</span> ("we", "us", "our"). By placing an order,
          you agree to these terms.
        </p>

        <div className="mt-10 space-y-8 text-gray-800">
          <MotionCard className="" delay={0.02}>
            <h2 className="text-lg font-semibold text-pink-500">1. Orders and Acceptance</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              All prices are quoted in South African Rand (ZAR) and are inclusive of VAT where applicable. Quotes are valid for thirty (30) days from the date of issue. Because these are custom-manufactured products, orders are non-cancellable once the design proof has been approved by the customer.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.05}>
            <h2 className="text-lg font-semibold text-pink-500">2. Pricing and Payment</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              A 50% deposit is required to confirm the order and commence production. The remaining 50% balance is due prior to dispatch. We accept secure EFT payments in South African Rand (ZAR) and all major credit cards.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.08}>
            <h2 className="text-lg font-semibold text-pink-500">3. Artwork Approval</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              A digital design proof will be provided within 24 hours of order confirmation at no cost. You are responsible for reviewing and approving the proof carefully. Once approved, changes may not be possible and may incur additional costs and production delays.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.11}>
            <h2 className="text-lg font-semibold text-pink-500">4. Production and Lead Times</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              Our standard lead time is 2–3 business days from final design approval, subject to production scheduling and order volume. For large or complex orders, an updated timeline will be communicated at the time of confirmation.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.14}>
            <h2 className="text-lg font-semibold text-pink-500">5. Delivery</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              We offer door-to-door delivery across Johannesburg, Pretoria, Sandton, Midrand, Kempton Park, and the greater Gauteng region. Delivery to other provinces is available at an additional cost. Risk of loss or damage passes to the customer upon delivery. Please inspect goods upon receipt and report any visible damage immediately.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.17}>
            <h2 className="text-lg font-semibold text-pink-500">6. Returns and Refunds</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              Custom branded mats are manufactured to order and are not returnable unless defective or produced incorrectly relative to the approved design proof. If there is a quality issue, contact us within 5 business days of delivery so we can assess and resolve it.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.20}>
            <h2 className="text-lg font-semibold text-pink-500">7. Warranty and Care</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              All mats are manufactured to SABS quality standards for safety and performance. Product lifespan depends on correct use and maintenance. Follow all care instructions provided with your order to achieve the best performance and longest service life.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.23}>
            <h2 className="text-lg font-semibold text-pink-500">8. Limitation of Liability</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              To the maximum extent permitted by law, our liability is limited to the value of the goods supplied. We are not liable for indirect or consequential losses such as lost profits, business interruption, or reputational damage.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.26}>
            <h2 className="text-lg font-semibold text-pink-500">9. Intellectual Property</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              You confirm that you hold the rights to any logos, trademarks, and artwork supplied for production. You indemnify us against any claims arising from the unauthorized use of third-party intellectual property.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.29}>
            <h2 className="text-lg font-semibold text-pink-500">10. Privacy Policy (POPIA)</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              We protect your personal data in accordance with the Protection of Personal Information Act (POPIA) of South Africa. We collect information solely to process your orders, communicate with you, and improve our service. We will never sell or share your personal data with third parties for marketing purposes.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.32}>
            <h2 className="text-lg font-semibold text-pink-500">11. Governing Law</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              These terms are governed by the laws of the Republic of South Africa. Any disputes arising from these terms shall be subject to the jurisdiction of the South African courts.
            </p>
          </MotionCard>

          <MotionCard className="" delay={0.35}>
            <h2 className="text-lg font-semibold text-pink-500">12. Contact</h2>
            <p className="mt-2 text-sm sm:text-base leading-relaxed">
              If you have questions about these terms, please contact us via the Contact page or email us directly at care@logobrandeddoormats.co.za.
            </p>
          </MotionCard>

          <p className="text-xs text-gray-500">Last updated: {new Date().getFullYear()}</p>
        </div>
      </div>
    </MotionSection>
    </>
  )
}
